import { render, staticRenderFns } from "./complaints-success.pug?vue&type=template&id=06a4afa7&lang=pug&external"
import script from "./complaints-success.js?vue&type=script&lang=js&external"
export * from "./complaints-success.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports